/* Fashly – sticky Add to Cart bar for mobile (Dawn 15)
 * Shows a bar at the bottom of the screen on product pages when the main
 * Add to Cart button is out of view. Tapping it presses the theme's own button,
 * so size selection, cart popup and tracking all work exactly as before.
 */
(function () {
  "use strict";

  var MOBILE = window.matchMedia("(max-width: 749px)");

  // Always look things up fresh: Dawn re-renders the product block when the size changes.
  function realButton() {
    return document.querySelector('product-form button[name="add"]');
  }
  function priceBox() {
    return document.querySelector('[id^="price-"][id$="__main"] .price, .product__info-container .price');
  }
  function selectedOptions() {
    var out = [];
    document.querySelectorAll("variant-selects fieldset, variant-radios fieldset").forEach(function (fs) {
      var legend = fs.querySelector("legend");
      var checked = fs.querySelector("input:checked");
      if (checked) out.push({ name: legend ? legend.textContent.trim() : "", value: checked.value });
    });
    document.querySelectorAll("variant-selects select").forEach(function (sel) {
      var label = document.querySelector('label[for="' + sel.id + '"]');
      out.push({ name: label ? label.textContent.trim() : "", value: sel.value });
    });
    return out;
  }
  function picker() {
    return document.querySelector("variant-selects, variant-radios");
  }

  if (!realButton()) return;

  // ---- Styles ----
  var css =
    "#fc-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:90;display:flex;align-items:center;gap:12px;" +
    "padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:rgb(var(--color-background,255,255,255));" +
    "box-shadow:0 -4px 16px rgba(0,0,0,.12);transform:translateY(110%);transition:transform .25s ease;}" +
    "#fc-sticky-atc.is-visible{transform:translateY(0);}" +
    "#fc-sticky-atc .fc-info{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;}" +
    "#fc-sticky-atc .fc-price{font-weight:700;font-size:1.6rem;line-height:1.2;white-space:nowrap;}" +
    "#fc-sticky-atc .fc-price s{font-weight:400;opacity:.6;font-size:1.3rem;margin-left:6px;}" +
    "#fc-sticky-atc .fc-opt{font-size:1.3rem;line-height:1.2;opacity:.8;background:none;border:0;padding:0;" +
    "text-align:left;text-decoration:underline;cursor:pointer;color:inherit;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" +
    "#fc-sticky-atc .fc-btn{flex:0 0 auto;min-width:150px;margin:0;}" +
    "#fc-sticky-atc .fc-btn[disabled]{opacity:.5;cursor:not-allowed;}" +
    "body.fc-sticky-on{padding-bottom:76px;}" +
    "@media (min-width:750px){#fc-sticky-atc{display:none!important;}body.fc-sticky-on{padding-bottom:0;}}";
  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  // ---- Bar ----
  var bar = document.createElement("div");
  bar.id = "fc-sticky-atc";
  bar.setAttribute("aria-hidden", "true");

  var info = document.createElement("div");
  info.className = "fc-info";
  var price = document.createElement("div");
  price.className = "fc-price";
  var opt = document.createElement("button");
  opt.type = "button";
  opt.className = "fc-opt";
  info.appendChild(price);
  info.appendChild(opt);

  var btn = document.createElement("button");
  btn.type = "button";
  btn.className = "button button--primary fc-btn";
  btn.tabIndex = -1;

  bar.appendChild(info);
  bar.appendChild(btn);
  document.body.appendChild(bar);

  // ---- Keep the bar in sync with the real product form ----
  function sync() {
    var rb = realButton();
    if (!rb) return;

    var label = rb.querySelector("span");
    btn.textContent = (label ? label.textContent : rb.textContent).trim() || "Add to cart";
    btn.disabled = rb.disabled || rb.getAttribute("aria-disabled") === "true" || rb.classList.contains("loading");

    var pb = priceBox();
    price.textContent = "";
    if (pb) {
      var onSale = pb.classList.contains("price--on-sale");
      var now = onSale
        ? pb.querySelector(".price__sale .price-item--last") || pb.querySelector(".price__sale .price-item--sale")
        : pb.querySelector(".price__regular .price-item--regular");
      var was = onSale ? pb.querySelector(".price__sale s.price-item--regular, .price__sale s .price-item--regular") : null;
      if (now) price.appendChild(document.createTextNode(now.textContent.trim()));
      if (was && was.textContent.trim()) {
        var s = document.createElement("s");
        s.textContent = was.textContent.trim();
        price.appendChild(s);
      }
    }

    var opts = selectedOptions();
    if (opts.length) {
      opt.textContent = opts.map(function (o) { return (o.name ? o.name + ": " : "") + o.value; }).join(" · ") + " – change";
      opt.style.display = "";
    } else {
      opt.style.display = "none";
    }
  }

  // ---- Show only on mobile, and only while the real button is off screen ----
  var ticking = false;
  function updateVisibility() {
    ticking = false;
    var rb = realButton();
    var show = false;
    if (MOBILE.matches && rb) {
      var r = rb.getBoundingClientRect();
      var offScreen = r.bottom < 0 || r.top > window.innerHeight;
      show = offScreen;
    }
    bar.classList.toggle("is-visible", show);
    bar.setAttribute("aria-hidden", show ? "false" : "true");
    document.body.classList.toggle("fc-sticky-on", MOBILE.matches);
  }
  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    }
  }

  // ---- Actions ----
  btn.addEventListener("click", function () {
    var rb = realButton();
    if (!rb || rb.disabled) return;
    rb.click(); // uses Dawn's own add-to-cart, cart popup and tracking
  });
  opt.addEventListener("click", function () {
    var p = picker();
    if (p) p.scrollIntoView({ behavior: "smooth", block: "center" });
  });

  // Re-sync whenever Dawn changes the product block (size change, add-to-cart loading state, etc.)
  var info_root = document.querySelector(".product__info-container") || document.body;
  new MutationObserver(function () {
    sync();
    requestUpdate();
  }).observe(info_root, { subtree: true, childList: true, attributes: true, attributeFilter: ["disabled", "class", "checked"] });
  document.addEventListener("change", function (e) {
    if (e.target.closest && e.target.closest("variant-selects, variant-radios")) setTimeout(sync, 0);
  });

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
  if (MOBILE.addEventListener) MOBILE.addEventListener("change", requestUpdate);

  sync();
  updateVisibility();
})();